import { Popover as BasePopover } from '@base-ui/react/popover'
import { PopoverTrigger } from './nested/trigger'
import { PopoverContent } from './nested/content'
import { PopoverPortal } from './nested/portal'
import { PopoverPositioner } from './nested/positioner'
import { PopoverPopup } from './nested/popup'
import { PopoverArrow } from './nested/arrow'
import { PopoverTitle } from './nested/title'
import { PopoverDescription } from './nested/description'
import { PopoverClose } from './nested/close'
import { PopoverBackdrop } from './nested/backdrop'
import type { PartProps } from '../../lib/part-props'

interface PopoverRootProps extends PartProps<BasePopover.Root.Props> {}

function Popover({ children, ...props }: PopoverRootProps) {
  return <BasePopover.Root {...props}>{children}</BasePopover.Root>
}

Popover.Trigger = PopoverTrigger
Popover.Content = PopoverContent
Popover.Portal = PopoverPortal
Popover.Backdrop = PopoverBackdrop
Popover.Positioner = PopoverPositioner
Popover.Popup = PopoverPopup
Popover.Arrow = PopoverArrow
Popover.Title = PopoverTitle
Popover.Description = PopoverDescription
Popover.Close = PopoverClose

export { Popover }
